import { style } from '@/styles/globals';

export const WarningIcon = ({
  color = '#AE5700',
}: {
  [key: string]: string;
}) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99968 3.33325C6.19968 3.33325 4.53301 4.06659 3.26634 5.33325C1.99967 6.59992 1.33301 8.33325 1.33301 10.1333C1.33301 13.7333 4.26634 16.6666 7.86634 16.6666H7.99968C11.7323 16.5999 14.6663 13.5999 14.6663 9.86659C14.6663 6.26659 11.7323 3.33325 8.13301 3.33325H7.99968ZM7.46634 7.05332C7.46634 6.71999 7.73301 6.51999 7.99967 6.51999C8.33301 6.51999 8.53301 6.78665 8.53301 7.05332V10.3867C8.53301 10.72 8.26634 10.92 7.99967 10.92C7.66634 10.92 7.46634 10.72 7.46634 10.3867V7.05332ZM7.99954 13.4867C8.47819 13.4867 8.86621 13.0987 8.86621 12.6201C8.86621 12.1414 8.47819 11.7534 7.99954 11.7534C7.52089 11.7534 7.13287 12.1414 7.13287 12.6201C7.13287 13.0987 7.52089 13.4867 7.99954 13.4867Z"
      fill={color}
    />
  </svg>
);
export const PassengerIcon = ({
  color = '#AE5700',
}: {
  [key: string]: string;
}) => (
  <svg
    width={13}
    height={13}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 3.333c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3-3 1.346-3 3ZM11.833 13h.667v-.667a4.673 4.673 0 0 0-4.667-4.666H5.167A4.672 4.672 0 0 0 .5 12.333V13h11.333Z"
      fill={color}
    />
  </svg>
);

export const SeatClassIcon = ({
  color = '#AE5700',
}: {
  [key: string]: string;
}) => (
  <svg
    width={11}
    height={14}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.167 11s-2-5.333-2-8S1.5.333 1.5.333h.667s.666 0 .666.667-.666.667-.666 2 2 2.667 2 4.667-2 3.333-2 3.333Zm3.333-.667C4.833 10.333 2.833 12 2.833 12c-.2.133-.133.333 0 .533 0 0 .667 1.2 2 1.2h4c.734 0 1.334-.6 1.334-1.333v-.667c0-.733-.6-1.333-1.334-1.333H5.5v-.067Z"
      fill={color}
    />
  </svg>
);

export const ErrorIcon = ({ color = '#D21C1C' }: { [key: string]: string }) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7611 3.33337H5.23825L1.33301 7.23862V12.7615L5.23825 16.6667H10.7611L14.6663 12.7615V7.23862L10.7611 3.33337ZM7.99982 6.52004C7.73315 6.52004 7.46648 6.72004 7.46648 7.05337V10.3867C7.46648 10.72 7.66648 10.92 7.99982 10.92C8.26648 10.92 8.53315 10.72 8.53315 10.3867V7.05337C8.53315 6.7867 8.33315 6.52004 7.99982 6.52004ZM8.86635 12.6201C8.86635 13.0987 8.47833 13.4868 7.99968 13.4868C7.52104 13.4868 7.13302 13.0987 7.13302 12.6201C7.13302 12.1415 7.52104 11.7534 7.99968 11.7534C8.47833 11.7534 8.86635 12.1415 8.86635 12.6201Z"
      fill={color}
    />
  </svg>
);

export const CheckedIcon = ({
  color = '#2BA138',
}: {
  [key: string]: string;
}) => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.6299 10.445C5.40116 10.2053 5.02137 10.1963 4.78161 10.4251C4.54184 10.6538 4.5329 11.0336 4.76164 11.2733L6.47668 13.1032C6.72193 13.3603 7.13559 13.3491 7.36663 13.0792L11.094 8.38816C11.3095 8.13642 11.2801 7.75766 11.0284 7.54218C10.7767 7.32669 10.3979 7.35609 10.1824 7.60783L7.07924 11.55C6.98814 11.6657 6.82048 11.6857 6.70476 11.5946C6.69399 11.5861 6.68389 11.5768 6.67455 11.5668L5.6299 10.445ZM1.33301 10C1.33301 6.33337 4.33301 3.33337 7.99967 3.33337C11.6663 3.33337 14.6663 6.33337 14.6663 10C14.6663 13.6667 11.6663 16.6667 7.99967 16.6667C4.33301 16.6667 1.33301 13.6667 1.33301 10Z"
      fill={color}
    />
  </svg>
);
export const HistoryIcon = ({ color = '#8897A5' }: { color?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.2605 2.99995C8.17052 2.85995 4.00052 6.94995 4.00052 12H2.21052C1.76052 12 1.54052 12.54 1.86052 12.85L4.65052 15.65C4.85052 15.8499 5.16052 15.8499 5.36052 15.65L8.15052 12.85C8.46052 12.54 8.24052 12 7.79052 12H6.00052C6.00052 8.09995 9.18052 4.94995 13.1005 4.99995C16.8205 5.04995 19.9505 8.17995 20.0005 11.9C20.0505 15.8099 16.9005 19 13.0005 19C11.3905 19 9.90052 18.45 8.72052 17.52C8.32052 17.21 7.76052 17.24 7.40052 17.6C6.98052 18.02 7.01052 18.73 7.48052 19.09C9.00052 20.29 10.9105 21 13.0005 21C18.0505 21 22.1405 16.83 22.0005 11.74C21.8705 7.04995 17.9505 3.12995 13.2605 2.99995ZM12.7505 7.99995C12.3405 7.99995 12.0005 8.33995 12.0005 8.74995V12.43C12.0005 12.78 12.1905 13.11 12.4905 13.29L15.6105 15.14C15.9705 15.35 16.4305 15.23 16.6405 14.88C16.8505 14.52 16.7305 14.06 16.3805 13.85L13.5005 12.14V8.73995C13.5005 8.33995 13.1605 7.99995 12.7505 7.99995Z"
      fill={color}
    />
  </svg>
);

export const LocationIcon = ({ color = '#8897A5' }: { color?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9997 1.92859C16.6154 1.92859 20.3569 5.67002 20.3569 10.2857C20.3569 13.8172 17.8754 17.6657 12.9769 21.8726C12.7045 22.1066 12.3572 22.2351 11.9981 22.2348C11.639 22.2345 11.292 22.1053 11.02 21.8709L10.696 21.5897C6.01429 17.4926 3.64258 13.7383 3.64258 10.2857C3.64258 5.67002 7.38401 1.92859 11.9997 1.92859ZM11.9997 7.07145C11.1472 7.07145 10.3297 7.41009 9.72688 8.01289C9.12408 8.61568 8.78544 9.43325 8.78544 10.2857C8.78544 11.1382 9.12408 11.9558 9.72688 12.5586C10.3297 13.1614 11.1472 13.5 11.9997 13.5C12.8522 13.5 13.6698 13.1614 14.2726 12.5586C14.8754 11.9558 15.214 11.1382 15.214 10.2857C15.214 9.43325 14.8754 8.61568 14.2726 8.01289C13.6698 7.41009 12.8522 7.07145 11.9997 7.07145Z"
      fill={color}
    />
  </svg>
);

export const BaggageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M14.493 5.667C14.493 5.917 14.833 6.083 15.083 6.083H16.583C17.75 6.083 18.5 7 18.5 8.083V19.083C18.5 20 17.833 20.917 16.833 21.083C16.75 21.083 16.5 21.25 16.5 21.333C16.5 21.833 16.166 22 15.666 22C15.166 22 14.833 21.833 14.833 21.333C14.8297 21.2899 14.8111 21.2494 14.7804 21.2189C14.7497 21.1884 14.7091 21.17 14.666 21.167H9.08299C9.04004 21.1702 8.99967 21.1888 8.96921 21.2192C8.93875 21.2497 8.92022 21.29 8.91699 21.333C8.91699 21.833 8.58299 22 8.08299 22C7.58299 22 7.24999 21.833 7.24999 21.333C7.24999 21.25 7.16699 21.083 7.08299 21.083C6.08299 20.917 5.41699 20.083 5.41699 19.083V8.083C5.41699 7 6.33299 6.083 7.49999 6H9.07699C9.32699 6 9.49299 5.833 9.49299 5.583V4.167C9.49299 3.917 9.32699 3.75 8.99299 3.667C8.49299 3.667 8.24299 3.25 8.24299 2.833C8.24299 2.417 8.49299 2 9.07699 2H14.91C15.493 2 15.743 2.333 15.743 2.833C15.743 3.333 15.493 3.75 14.91 3.75C14.66 3.75 14.493 3.917 14.493 4.167V5.667ZM11.577 3.667C11.327 3.667 11.16 3.833 11.16 4.083V5.58C11.16 5.83 11.327 5.997 11.577 5.997H12.41C12.66 5.997 12.827 5.83 12.827 5.58V4.083C12.827 3.833 12.66 3.667 12.41 3.667H11.577ZM14.25 9C14.0511 9 13.8603 9.07902 13.7197 9.21967C13.579 9.36032 13.5 9.55109 13.5 9.75V17.25C13.5 17.4489 13.579 17.6397 13.7197 17.7803C13.8603 17.921 14.0511 18 14.25 18C14.4489 18 14.6397 17.921 14.7803 17.7803C14.921 17.6397 15 17.4489 15 17.25V9.75C15 9.55109 14.921 9.36032 14.7803 9.21967C14.6397 9.07902 14.4489 9 14.25 9ZM9.74999 9C9.55108 9 9.36031 9.07902 9.21966 9.21967C9.07901 9.36032 8.99999 9.55109 8.99999 9.75V17.25C8.99999 17.4489 9.07901 17.6397 9.21966 17.7803C9.36031 17.921 9.55108 18 9.74999 18C9.9489 18 10.1397 17.921 10.2803 17.7803C10.421 17.6397 10.5 17.4489 10.5 17.25V9.75C10.5 9.55109 10.421 9.36032 10.2803 9.21967C10.1397 9.07902 9.9489 9 9.74999 9Z"
      fill="#425062"
    />
  </svg>
);

export const SearchIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="11.058"
      cy="11.0586"
      r="7.06194"
      stroke="#667487"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.0024 20.0033L16.0508 16.0516"
      stroke="#667487"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const ArroundNearMeIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.7496 3.94046L4.06962 10.0805C3.23962 10.4305 3.25962 11.6105 4.08962 11.9305L9.42962 14.0005C9.55898 14.0507 9.67647 14.1273 9.7746 14.2255C9.87273 14.3236 9.94937 14.4411 9.99962 14.5705L12.0596 19.9005C12.3796 20.7405 13.5696 20.7605 13.9196 19.9305L20.0696 5.26046C20.3996 4.43046 19.5696 3.60046 18.7496 3.94046Z"
      fill={style.color.product3}
    />
  </svg>
);

export const LeadingIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      fill="url(#pattern0)"
    />
    <defs>
      <pattern
        id="pattern0"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1"
      >
        <use
          xlinkHref="#image0"
          transform="scale(0.0078125)"
        />
      </pattern>
      <image
        id="image0"
        width="128"
        height="128"
        xlinkHref="data:image/png;base64,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"
      />
    </defs>
  </svg>
);
export const VectorIcon = ({ color }: { color: string }) => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.65741 5.7695L3.38516 0.102501L0.112914 5.7695L2.06141 5.7695L2.06142 19.9992L4.68642 19.9992L4.68641 5.7695L6.65741 5.7695ZM10.5934 14.333L13.8649 20L17.1364 14.333L15.1879 14.333L15.1879 0.1025L12.5629 0.1025L12.5629 14.333L10.5934 14.333Z"
      fill={color}
    />
  </svg>
);

export const VectorDesktopIcon = ({ color }: { color: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M13.1844 8.12622L17.718 5.50842L13.1844 2.89062V4.44943H1.80065V6.54943H13.1844V8.12622ZM6.33365 11.275L1.80005 13.8922L6.33365 16.5094V14.9506H17.718V12.8506H6.33365V11.275Z"
      fill={color}
    />
  </svg>
);

export const FilterIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 10.5C2 10.3674 2.05268 10.2402 2.14645 10.1464C2.24021 10.0527 2.36739 10 2.5 10H5.5C5.63261 10 5.75979 10.0527 5.85355 10.1464C5.94732 10.2402 6 10.3674 6 10.5C6 10.6326 5.94732 10.7598 5.85355 10.8536C5.75979 10.9473 5.63261 11 5.5 11H2.5C2.36739 11 2.24021 10.9473 2.14645 10.8536C2.05268 10.7598 2 10.6326 2 10.5ZM2 7.5C2 7.36739 2.05268 7.24021 2.14645 7.14645C2.24021 7.05268 2.36739 7 2.5 7H9.5C9.63261 7 9.75979 7.05268 9.85355 7.14645C9.94732 7.24021 10 7.36739 10 7.5C10 7.63261 9.94732 7.75979 9.85355 7.85355C9.75979 7.94732 9.63261 8 9.5 8H2.5C2.36739 8 2.24021 7.94732 2.14645 7.85355C2.05268 7.75979 2 7.63261 2 7.5ZM2 4.5C2 4.36739 2.05268 4.24021 2.14645 4.14645C2.24021 4.05268 2.36739 4 2.5 4H13.5C13.6326 4 13.7598 4.05268 13.8536 4.14645C13.9473 4.24021 14 4.36739 14 4.5C14 4.63261 13.9473 4.75979 13.8536 4.85355C13.7598 4.94732 13.6326 5 13.5 5H2.5C2.36739 5 2.24021 4.94732 2.14645 4.85355C2.05268 4.75979 2 4.63261 2 4.5Z"
      fill="black"
    />
  </svg>
);

export const FlightArrowLineIcon = () => (
  <svg
    width="56"
    height="8"
    viewBox="0 0 56 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M55.3213 4.30277C55.5166 4.10751 55.5166 3.79093 55.3213 3.59567L52.1393 0.413685C51.9441 0.218423 51.6275 0.218423 51.4322 0.413685C51.237 0.608947 51.237 0.925529 51.4322 1.12079L54.2607 3.94922L51.4322 6.77765C51.237 6.97291 51.237 7.28949 51.4322 7.48475C51.6275 7.68001 51.9441 7.68001 52.1393 7.48475L55.3213 4.30277ZM54.9678 3.44922L0.967773 3.44922V4.44922L54.9678 4.44922V3.44922Z"
      fill="#212529"
    />
  </svg>
);
export const BagIcon = () => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.69444 2.04167H8.02778V1.48611C8.02778 0.875 7.52778 0.375 6.91667 0.375H4.69444C4.08333 0.375 3.58333 0.875 3.58333 1.48611V2.04167H1.91667C0.972222 2.04167 0.25 2.76389 0.25 3.70833V8.70833C0.25 9.65278 0.972222 10.375 1.91667 10.375H9.69444C10.6389 10.375 11.3611 9.65278 11.3611 8.70833V3.70833C11.3611 2.76389 10.6389 2.04167 9.69444 2.04167ZM4.69444 1.48611H6.91667V2.04167H4.69444V1.48611ZM10.25 8.70833C10.25 9.04167 10.0278 9.26389 9.69444 9.26389H1.91667C1.58333 9.26389 1.36111 9.04167 1.36111 8.70833V5.59722L3.97222 6.48611H7.47222C7.52778 6.48611 7.58333 6.48611 7.63889 6.43056L10.25 5.54167V8.70833Z"
      fill="black"
    />
  </svg>
);

export const InfoIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.06732 3.86634C8.06732 3.40412 7.66287 2.99967 7.20065 2.99967C6.73843 2.99967 6.33398 3.40412 6.33398 3.86634C6.33398 4.32856 6.68065 4.73301 7.20065 4.73301C7.72065 4.73301 8.06732 4.32856 8.06732 3.86634ZM6.22287 10.333H8.4451C8.77843 10.333 9.00065 10.1757 9.00065 9.8611C9.00065 9.54649 8.77843 9.33675 8.4451 9.33675H8.00065C7.9451 9.33675 7.88954 9.28432 7.88954 9.23188V6.71503C7.88954 6.13825 7.38954 5.66634 6.77843 5.66634H6.22287C5.88954 5.66634 5.66732 5.87608 5.66732 6.19069C5.66732 6.50529 5.88954 6.71503 6.22287 6.71503H6.66732C6.72287 6.71503 6.77843 6.76746 6.77843 6.8199V9.17945C6.77843 9.23188 6.72287 9.28432 6.66732 9.28432H6.22287C5.88954 9.28432 5.66732 9.49406 5.66732 9.80866C5.66732 10.1233 5.88954 10.333 6.22287 10.333ZM7.00065 0.333008C3.33398 0.333008 0.333984 3.33301 0.333984 6.99967C0.333984 10.6663 3.33398 13.6663 7.00065 13.6663C10.6673 13.6663 13.6673 10.6663 13.6673 6.99967C13.6673 3.33301 10.6673 0.333008 7.00065 0.333008Z"
      fill="#8897A5"
    />
  </svg>
);

export const MaleGenderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
  >
    <path
      d="M6.99935 6.00004C8.28801 6.00004 9.33268 4.95537 9.33268 3.66671C9.33268 2.37804 8.28801 1.33337 6.99935 1.33337C5.71068 1.33337 4.66602 2.37804 4.66602 3.66671C4.66602 4.95537 5.71068 6.00004 6.99935 6.00004Z"
      stroke="#1890FF"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99935 14.6667H5.99935L1.66602 8H12.3327L7.99935 14.6667Z"
      stroke="#1890FF"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const FemaleGenderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
  >
    <path
      d="M6.49935 6.00004C7.78801 6.00004 8.83268 4.95537 8.83268 3.66671C8.83268 2.37804 7.78801 1.33337 6.49935 1.33337C5.21068 1.33337 4.16602 2.37804 4.16602 3.66671C4.16602 4.95537 5.21068 6.00004 6.49935 6.00004Z"
      stroke="#F72585"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.49935 8H5.49935L1.16602 14.6667H11.8327L7.49935 8Z"
      stroke="#F72585"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const MyTicketIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
  >
    <path
      d="M16.5 1.5L15 0L13.5 1.5L12 0L10.5 1.5L9 0L7.5 1.5L6 0L4.5 1.5L3 0V14H1C0.45 14 0 14.45 0 15V17C0 18.66 1.34 20 3 20H15C16.66 20 18 18.66 18 17V0L16.5 1.5ZM12 18H3C2.45 18 2 17.55 2 17V16H5H9H12V18ZM16 17C16 17.55 15.55 18 15 18C14.45 18 14 17.55 14 17V15C14 14.45 13.55 14 13 14H11H9H5V3H16V17Z"
      fill="#828282"
    />
  </svg>
);

export const PolicyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M22.5 13.4998C22.5015 12.7488 22.315 12.0094 21.9576 11.3489C21.6001 10.6884 21.083 10.1279 20.4535 9.71839C19.8239 9.30893 19.1019 9.06354 18.3532 9.0046C17.6045 8.94566 16.8529 9.07504 16.167 9.38095C15.4812 9.68685 14.8827 10.1596 14.4263 10.756C13.9699 11.3524 13.67 12.0536 13.554 12.7955C13.438 13.5375 13.5095 14.2968 13.7621 15.0041C14.0147 15.7113 14.4402 16.3441 15 16.8448V22.4998L18 21.0801L21 22.4998V16.8448C21.4715 16.4244 21.8489 15.909 22.1074 15.3326C22.3659 14.7561 22.4997 14.1316 22.5 13.4998ZM19.5 20.1298L18 19.4196L16.5 20.1298V17.7373C17.4694 18.0874 18.5306 18.0874 19.5 17.7373V20.1298ZM18 16.4998C17.4066 16.4998 16.8266 16.3239 16.3333 15.9942C15.8399 15.6646 15.4554 15.196 15.2284 14.6479C15.0013 14.0997 14.9419 13.4965 15.0576 12.9145C15.1734 12.3326 15.4591 11.7981 15.8787 11.3785C16.2982 10.9589 16.8328 10.6732 17.4147 10.5575C17.9967 10.4417 18.5999 10.5011 19.148 10.7282C19.6962 10.9552 20.1648 11.3398 20.4944 11.8331C20.824 12.3265 21 12.9065 21 13.4998C20.999 14.2952 20.6826 15.0576 20.1202 15.62C19.5578 16.1824 18.7953 16.4988 18 16.4998Z"
      fill="black"
    />
    <path
      d="M6.75 10.5H12V12H6.75V10.5Z"
      fill="black"
    />
    <path
      d="M6.75 6H14.25V7.5H6.75V6Z"
      fill="black"
    />
    <path
      d="M4.5 22.5C4.1023 22.4996 3.721 22.3414 3.43978 22.0602C3.15856 21.779 3.0004 21.3977 3 21V3C3.0004 2.6023 3.15856 2.221 3.43978 1.93978C3.721 1.65856 4.1023 1.5004 4.5 1.5H16.5C16.8977 1.5004 17.279 1.65856 17.5602 1.93978C17.8414 2.221 17.9996 2.6023 18 3V6H16.5V3H4.5V21H12V22.5H4.5Z"
      fill="black"
    />
  </svg>
);
export const ShieldCheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.8334 4.93333C19.3227 4.53014 17.8469 4.00623 16.4201 3.36667C15.0164 2.75774 13.6613 2.04232 12.3667 1.22667L12.0001 1L11.6401 1.23333C10.3455 2.04899 8.99046 2.76441 7.58675 3.37333C6.15761 4.01096 4.67951 4.53264 3.16675 4.93333L2.66675 5.06V10.62C2.66675 19.5467 11.6867 22.8867 11.7734 22.92L12.0001 23L12.2267 22.92C12.3201 22.92 21.3334 19.5533 21.3334 10.62V5.06L20.8334 4.93333ZM20.0001 10.62C20.0001 17.9533 13.3334 21.0267 12.0001 21.5733C10.6667 21.0267 4.00008 17.9467 4.00008 10.62V6.09333C5.4064 5.68904 6.78302 5.18784 8.12008 4.59333C9.45723 4.01533 10.7535 3.34712 12.0001 2.59333C13.2466 3.34712 14.5429 4.01533 15.8801 4.59333C17.2171 5.18784 18.5938 5.68904 20.0001 6.09333V10.62Z"
      fill="black"
    />
    <path
      d="M7.25338 11.2469C7.12585 11.1377 6.9618 11.0806 6.79401 11.0871C6.62623 11.0936 6.46707 11.1631 6.34834 11.2818C6.22961 11.4006 6.16005 11.5597 6.15357 11.7275C6.14709 11.8953 6.20416 12.0594 6.31338 12.1869L10.3134 16.1869L17.6 9.18022C17.7274 9.05646 17.8003 8.88719 17.8028 8.70965C17.8053 8.53212 17.7371 8.36086 17.6134 8.23356C17.4896 8.10625 17.3203 8.03333 17.1428 8.03083C16.9653 8.02833 16.794 8.09646 16.6667 8.22022L10.3534 14.3469L7.25338 11.2469Z"
      fill="black"
    />
  </svg>
);

export const ShieldLockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
  >
    <path
      d="M7.33976 2.18625C6.03019 2.54716 4.72952 2.93961 3.43888 3.36325C3.32103 3.40143 3.21627 3.47193 3.13653 3.56674C3.0568 3.66155 3.00529 3.77685 2.98788 3.8995C2.22613 9.61538 3.98613 13.7858 6.08576 16.533C6.97472 17.7078 8.03469 18.7427 9.23038 19.6034C9.70613 19.9389 10.1269 20.1809 10.4583 20.3363C10.6233 20.4146 10.758 20.4669 10.8611 20.4985C10.9062 20.5143 10.9527 20.5258 11 20.5329C11.0467 20.5253 11.0927 20.5138 11.1375 20.4985C11.242 20.4669 11.3768 20.4146 11.5418 20.3363C11.8718 20.1809 12.2939 19.9375 12.7696 19.6034C13.9653 18.7427 15.0253 17.7078 15.9143 16.533C18.0139 13.7871 19.7739 9.61538 19.0121 3.8995C18.9949 3.77679 18.9434 3.66142 18.8637 3.56658C18.7839 3.47175 18.6791 3.40128 18.5611 3.36325C17.666 3.07038 16.1549 2.59325 14.6603 2.18762C13.134 1.77375 11.7301 1.46713 11 1.46713C10.2713 1.46713 8.86601 1.77375 7.33976 2.18762V2.18625ZM6.97401 0.77C8.46588 0.364375 10.0513 0 11 0C11.9488 0 13.5341 0.364375 15.026 0.77C16.5523 1.1825 18.0909 1.67062 18.9956 1.96625C19.3739 2.09117 19.7093 2.32026 19.9632 2.62721C20.2171 2.93416 20.3793 3.30652 20.4311 3.7015C21.2506 9.85738 19.349 14.4196 17.0418 17.4377C16.0634 18.7288 14.8967 19.8658 13.5809 20.8106C13.1259 21.1376 12.6438 21.4251 12.1399 21.67C11.7549 21.8515 11.341 22 11 22C10.659 22 10.2465 21.8515 9.86013 21.67C9.35621 21.4251 8.87413 21.1376 8.41913 20.8106C7.1033 19.8658 5.93668 18.7288 4.95826 17.4377C2.65101 14.4196 0.749382 9.85738 1.56888 3.7015C1.6207 3.30652 1.78289 2.93416 2.03682 2.62721C2.29074 2.32026 2.62611 2.09117 3.00438 1.96625C4.31777 1.53561 5.64137 1.13675 6.97401 0.77Z"
      fill="black"
    />
    <path
      d="M13.0625 8.9374C13.0627 9.36409 12.9306 9.78036 12.6843 10.1288C12.4381 10.4773 12.0898 10.7408 11.6875 10.883L12.2169 13.6193C12.2361 13.7188 12.2331 13.8213 12.2081 13.9196C12.1831 14.0178 12.1367 14.1093 12.0722 14.1875C12.0076 14.2657 11.9266 14.3286 11.8349 14.3718C11.7432 14.415 11.6431 14.4374 11.5418 14.4374H10.4583C10.357 14.4372 10.257 14.4147 10.1655 14.3714C10.074 14.3281 9.99314 14.2651 9.92877 14.1869C9.86441 14.1088 9.8181 14.0174 9.79316 13.9192C9.76822 13.8211 9.76526 13.7187 9.7845 13.6193L10.3125 10.883C9.95605 10.757 9.64109 10.5354 9.40205 10.2425C9.16301 9.94958 9.00909 9.59659 8.9571 9.2221C8.9051 8.84762 8.95705 8.46605 9.10725 8.11909C9.25745 7.77213 9.50013 7.47313 9.80877 7.25476C10.1174 7.0364 10.4801 6.90708 10.8573 6.88092C11.2345 6.85476 11.6116 6.93278 11.9474 7.10645C12.2832 7.28012 12.5649 7.54276 12.7615 7.86567C12.9582 8.18857 13.0623 8.55932 13.0625 8.9374Z"
      fill="black"
    />
  </svg>
);

export const FileProtectedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M15.1102 15.6844C15.0928 15.6602 15.0699 15.6406 15.0434 15.6271C15.0169 15.6137 14.9875 15.6068 14.9578 15.607H13.9219C13.7695 15.607 13.6805 15.7805 13.7695 15.9047L15.4992 18.2977C15.5742 18.4008 15.7266 18.4008 15.8016 18.2977L18.4781 14.5945C18.5672 14.4703 18.4781 14.2969 18.3258 14.2969H17.2875C17.2266 14.2969 17.1703 14.325 17.1352 14.3742L15.6469 16.432L15.1102 15.6844ZM16.125 7.17188V6.04688C16.125 5.94375 16.0406 5.85938 15.9375 5.85938H6.9375C6.83437 5.85938 6.75 5.94375 6.75 6.04688V7.17188C6.75 7.275 6.83437 7.35938 6.9375 7.35938H15.9375C16.0406 7.35938 16.125 7.275 16.125 7.17188ZM6.9375 9.23438C6.83437 9.23438 6.75 9.31875 6.75 9.42188V10.5469C6.75 10.65 6.83437 10.7344 6.9375 10.7344H11.25C11.3531 10.7344 11.4375 10.65 11.4375 10.5469V9.42188C11.4375 9.31875 11.3531 9.23438 11.25 9.23438H6.9375ZM11.25 19.9688H4.875V3.46875H18V10.4062C18 10.5094 18.0844 10.5938 18.1875 10.5938H19.5C19.6031 10.5938 19.6875 10.5094 19.6875 10.4062V2.53125C19.6875 2.11641 19.3523 1.78125 18.9375 1.78125H3.9375C3.52266 1.78125 3.1875 2.11641 3.1875 2.53125V20.9062C3.1875 21.3211 3.52266 21.6562 3.9375 21.6562H11.25C11.3531 21.6562 11.4375 21.5719 11.4375 21.4688V20.1562C11.4375 20.0531 11.3531 19.9688 11.25 19.9688ZM20.6859 12.45L16.1859 10.8867C16.1648 10.8797 16.1461 10.8773 16.125 10.8773C16.1039 10.8773 16.0828 10.8797 16.0641 10.8867L11.5641 12.45C11.5273 12.4625 11.4953 12.4861 11.4727 12.5176C11.45 12.5492 11.4377 12.587 11.4375 12.6258V18.5109C11.4375 18.5695 11.4633 18.6234 11.5102 18.6586L16.0102 22.1789C16.043 22.2047 16.0852 22.2188 16.125 22.2188C16.1648 22.2188 16.207 22.2047 16.2398 22.1789L20.7398 18.6586C20.7844 18.6234 20.8125 18.5695 20.8125 18.5109V12.6258C20.8125 12.5461 20.7609 12.4758 20.6859 12.45ZM19.3594 17.8992L16.125 20.4281L12.8906 17.8992V13.5234L16.125 12.3984L19.3594 13.5234V17.8992Z"
      fill="black"
    />
  </svg>
);

interface ISelected {
  selected: boolean;
}

export const AngryFaceIcon = ({ selected }: ISelected) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width="20px"
    height="20px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 48 48"
  >
    <g
      fill={selected ? '#0172CB' : 'none'}
      stroke={selected ? '#fff' : 'currentColor'}
      strokeWidth="3"
      strokeLinejoin="round"
    >
      <path d="M24 44c11.046 0 20-8.954 20-20S35.046 4 24 4S4 12.954 4 24s8.954 20 20 20z" />
      <path
        d="M31 35s-2-4-7-4s-7 4-7 4"
        strokeLinecap="round"
      />
      <path
        d="M33 19l-4 2"
        strokeLinecap="round"
      />
      <path
        d="M15 19l4 2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const FaceSadIcon = ({ selected }: ISelected) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width="20px"
    height="20px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <g fill={selected ? '#0172CB' : 'none'}>
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M8 9.05v-.1"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 9.05v-.1"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 16c-.5-1.5-1.79-3-4-3s-3.5 1.5-4 3"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const FaceNeutralIcon = ({ selected }: ISelected) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width="20px"
    height="20px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <g fill={selected ? '#0172CB' : 'none'}>
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M8 9.05v-.1"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 9.05v-.1"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8 14h8"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </g>
  </svg>
);

export const FaceHappyIcon = ({ selected }: ISelected) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width="20px"
    height="20px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <g fill={selected ? '#0172CB' : 'none'}>
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M8 9.05v-.1"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 9.05v-.1"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 14c-.5 1.5-1.79 3-4 3s-3.5-1.5-4-3"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const FaceVeryHappyIcon = ({ selected }: ISelected) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width="20px"
    height="20px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 24 24"
  >
    <g fill={selected ? '#0172CB' : 'none'}>
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="1"
        strokeLinecap="round"
      />
      <path
        d="M8 9.05v-.1"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 9.05v-.1"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12 18a4 4 0 0 0 4-4H8a4 4 0 0 0 4 4z"
        stroke={selected ? '#fff' : 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export const HealthIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    role="img"
    width="24px"
    height="24px"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 48 48"
  >
    <g fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 7a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3h3a3 3 0 0 1 3 3v15h-2V10a1 1 0 0 0-1-1h-3a3 3 0 0 1-3 3h-8a3 3 0 0 1-3-3h-3a1 1 0 0 0-1 1v28a1 1 0 0 0 1 1h12v2H14a3 3 0 0 1-3-3V10a3 3 0 0 1 3-3h3zm3-1a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-8zm3 10v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2zm5 11a1 1 0 0 0-1 1v6.789a7 7 0 0 0 3.117 5.824l3.328 2.22a1 1 0 0 0 1.11 0l3.328-2.22A7 7 0 0 0 41 34.79V28a1 1 0 0 0-1-1H28zm9.707 5.707l-4 4a1 1 0 0 1-1.414 0l-2-2l1.414-1.414L33 34.586l3.293-3.293l1.414 1.414z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const FlightTransitArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="55"
    height="13"
    viewBox="0 0 55 13"
    fill="none"
  >
    <path
      d="M54.9688 5.94922L47.4688 1.61909V10.2793L54.9688 5.94922ZM48.2188 5.19922L0.96875 5.19922V6.69922L48.2188 6.69922V5.19922Z"
      fill="#212529"
    />
    <path
      d="M54.9688 5.94922L47.4688 1.61909V10.2793L54.9688 5.94922ZM48.2188 5.19922L0.96875 5.19922V6.69922L48.2188 6.69922V5.19922Z"
      fill="#666666"
    />
    <circle
      cx="27.9688"
      cy="5.94922"
      r="4"
      fill="white"
      stroke="#666666"
      strokeWidth="2"
    />
  </svg>
);

export const SearchBusDistrictIcon = ({ color = '8897A5' }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
  >
    <path
      d="M16 13H14V11H16V13ZM16 17H14V15H16V17ZM10 5H8V3H10V5ZM10 9H8V7H10V9ZM10 13H8V11H10V13ZM10 17H8V15H10V17ZM4 9H2V7H4V9ZM4 13H2V11H4V13ZM4 17H2V15H4V17ZM12 9V3L9 0L6 3V5H0V19H18V9H12Z"
      fill={color}
    />
  </svg>
);

export const CheckCircleIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="108"
    height="108"
    viewBox="0 0 109 108"
    fill="none"
  >
    <g filter="url(#filter0_d_2756_51369)">
      <path
        d="M27.498 50C27.498 35.1569 39.6549 23 54.498 23C69.3412 23 81.498 35.1569 81.498 50C81.498 64.8431 69.3412 77 54.498 77C39.6549 77 27.498 64.8431 27.498 50Z"
        stroke="#FDF0E3"
        strokeWidth="6"
      />
      <path
        d="M27.5 50C27.5 64.85 39.65 77 54.5 77C69.35 77 81.5 64.85 81.5 50C81.5 35.15 69.35 23 54.5 23"
        stroke="#E98305"
        strokeWidth="6"
        strokeLinecap="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.713 50.4135C43.7811 49.4367 42.2339 49.4003 41.2571 50.3321C40.2803 51.264 40.2439 52.8112 41.1757 53.788L48.1628 61.2429C49.1619 62.2902 50.8471 62.2447 51.7884 61.1451L66.9737 42.0339C67.8515 41.0084 67.7318 39.4653 66.7062 38.5874C65.6806 37.7096 64.1376 37.8293 63.2597 38.8549L50.6175 54.915C50.2464 55.3864 49.5634 55.4678 49.0919 55.0967C49.0481 55.0621 49.0069 55.0243 48.9689 54.9834L44.713 50.4135Z"
        fill="#FAE2C7"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_2756_51369"
        x="-5.5"
        y="-6"
        width="120"
        height="120"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="12" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0285937 0 0 0 0 0.254167 0 0 0 0 0.222133 0 0 0 0.08 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2756_51369"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2756_51369"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const TimeCountDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="31"
    height="36"
    viewBox="0 0 31 36"
    fill="none"
  >
    <path
      d="M0.5 1.75C0.5 1.41848 0.631696 1.10054 0.866117 0.866116C1.10054 0.631696 1.41848 0.5 1.75 0.5H29.25C29.5815 0.5 29.8995 0.631696 30.1339 0.866116C30.3683 1.10054 30.5 1.41848 30.5 1.75C30.5 2.08152 30.3683 2.39946 30.1339 2.63388C29.8995 2.8683 29.5815 3 29.25 3H26.75V5.5C26.7505 7.62258 26.1505 9.702 25.0194 11.4981C23.8882 13.2941 22.272 14.7335 20.3575 15.65C19.6325 15.9975 19.25 16.5925 19.25 17.125V18.875C19.25 19.4075 19.635 20.0025 20.3575 20.35C22.272 21.2665 23.8882 22.7059 25.0194 24.5019C26.1505 26.298 26.7505 28.3774 26.75 30.5V33H29.25C29.5815 33 29.8995 33.1317 30.1339 33.3661C30.3683 33.6005 30.5 33.9185 30.5 34.25C30.5 34.5815 30.3683 34.8995 30.1339 35.1339C29.8995 35.3683 29.5815 35.5 29.25 35.5H1.75C1.41848 35.5 1.10054 35.3683 0.866117 35.1339C0.631696 34.8995 0.5 34.5815 0.5 34.25C0.5 33.9185 0.631696 33.6005 0.866117 33.3661C1.10054 33.1317 1.41848 33 1.75 33H4.25V30.5C4.24949 28.3774 4.84946 26.298 5.98062 24.5019C7.11179 22.7059 8.72798 21.2665 10.6425 20.35C11.3675 20.0025 11.75 19.4075 11.75 18.875V17.125C11.75 16.5925 11.365 15.9975 10.6425 15.65C8.72798 14.7335 7.11179 13.2941 5.98062 11.4981C4.84946 9.702 4.24949 7.62258 4.25 5.5V3H1.75C1.41848 3 1.10054 2.8683 0.866117 2.63388C0.631696 2.39946 0.5 2.08152 0.5 1.75ZM6.75 3V5.5C6.74955 7.15105 7.21623 8.76854 8.09613 10.1656C8.97603 11.5626 10.2332 12.6822 11.7225 13.395C13.055 14.035 14.25 15.3725 14.25 17.1225V18.8775C14.25 18.8775 14.7 19.25 15.5 19.25C16.3 19.25 16.75 18.875 16.75 18.875V17.125C16.75 15.3725 17.945 14.035 19.2775 13.395C20.7668 12.6822 22.024 11.5626 22.9039 10.1656C23.7838 8.76854 24.2505 7.15105 24.25 5.5V3H6.75Z"
      fill="#0172CB"
    />
  </svg>
);

export const ExipreCountDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
  >
    <path
      d="M20.4993 33.3332C17.4052 33.3332 14.4377 32.104 12.2498 29.9161C10.0618 27.7282 8.83268 24.7607 8.83268 21.6665C8.83268 19.5332 9.41602 17.4998 10.416 15.8332L26.3327 31.7332C24.666 32.7498 22.6327 33.3332 20.4993 33.3332ZM5.49935 6.6665L3.41602 8.78317L7.99935 13.3832C6.36181 15.8347 5.49149 18.7184 5.49935 21.6665C5.49935 25.6448 7.0797 29.4601 9.89275 32.2731C12.7058 35.0862 16.5211 36.6665 20.4993 36.6665C23.566 36.6665 26.416 35.7498 28.8327 34.1665L32.9993 38.3332L35.0827 36.2165L22.2327 23.3332L5.49935 6.6665ZM18.8327 15.7332L22.166 19.0665V13.3332H18.8327V15.7332ZM25.4993 1.6665H15.4993V4.99984H25.4993V1.6665ZM32.2327 7.58317L29.866 9.94984C27.2061 7.8256 23.9034 6.66791 20.4993 6.6665C17.4493 6.6665 14.616 7.58317 12.2493 9.1665L14.666 11.5665C16.3827 10.5832 18.3827 9.99984 20.4993 9.99984C23.5935 9.99984 26.561 11.229 28.7489 13.4169C30.9369 15.6049 32.166 18.5723 32.166 21.6665C32.166 23.7832 31.5827 25.7832 30.5993 27.4998L32.9993 29.8998C34.5827 27.5498 35.4993 24.7165 35.4993 21.6665C35.4993 18.1332 34.266 14.8832 32.216 12.3165L34.5827 9.94984L32.2327 7.58317Z"
      fill="#D21C1C"
    />
  </svg>
);
export const YellowArrowUp = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="8"
    viewBox="0 0 16 8"
    fill="none"
  >
    <path
      d="M16 8H0L6.58579 1.41421C7.36684 0.633165 8.63316 0.633164 9.41421 1.41421L16 8Z"
      fill="#FFD333"
    />
  </svg>
);

export const SearchBusIcon = ({ color = '#8897A5' }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
  >
    <path
      d="M5.01168 0C3.06782 0 0.736328 1.08973 0.736328 4.02747V17.6C0.736328 17.6 0.736328 19.0667 2.16145 19.0667V20.5333C2.16145 20.5333 2.16145 22 3.58656 22C5.01168 22 5.01168 20.5333 5.01168 20.5333V19.0667H14.9875V20.5333C14.9875 20.5333 14.9875 22 16.4126 22C17.8377 22 17.8377 20.5333 17.8377 20.5333V19.0667C17.8377 19.0667 19.2629 19.0667 19.2629 17.6V4.02747C19.2629 1.02813 17.5014 0 15.5576 0H5.01168ZM5.36796 2.2H14.6312C14.7257 2.2 14.8163 2.23863 14.8832 2.30739C14.95 2.37616 14.9875 2.46942 14.9875 2.56667C14.9875 2.66391 14.95 2.75718 14.8832 2.82594C14.8163 2.8947 14.7257 2.93333 14.6312 2.93333H5.36796C5.27347 2.93333 5.18285 2.8947 5.11603 2.82594C5.04922 2.75718 5.01168 2.66391 5.01168 2.56667C5.01168 2.46942 5.04922 2.37616 5.11603 2.30739C5.18285 2.23863 5.27347 2.2 5.36796 2.2ZM3.58656 4.4H16.4126C17.8377 4.4 17.8377 5.81827 17.8377 5.81827V10.2667C17.8377 10.2667 17.8377 11.7333 16.4126 11.7333H3.58656C2.16145 11.7333 2.16145 10.2667 2.16145 10.2667V5.86667C2.16145 5.86667 2.16145 4.4 3.58656 4.4ZM3.58656 14.6667C3.96453 14.6667 4.32701 14.8212 4.59427 15.0962C4.86154 15.3713 5.01168 15.7443 5.01168 16.1333C5.01168 16.5223 4.86154 16.8954 4.59427 17.1704C4.32701 17.4455 3.96453 17.6 3.58656 17.6C3.2086 17.6 2.84611 17.4455 2.57885 17.1704C2.31159 16.8954 2.16145 16.5223 2.16145 16.1333C2.16145 15.7443 2.31159 15.3713 2.57885 15.0962C2.84611 14.8212 3.2086 14.6667 3.58656 14.6667ZM16.4126 14.6667C16.7906 14.6667 17.1531 14.8212 17.4203 15.0962C17.6876 15.3713 17.8377 15.7443 17.8377 16.1333C17.8377 16.5223 17.6876 16.8954 17.4203 17.1704C17.1531 17.4455 16.7906 17.6 16.4126 17.6C16.0347 17.6 15.6722 17.4455 15.4049 17.1704C15.1377 16.8954 14.9875 16.5223 14.9875 16.1333C14.9875 15.7443 15.1377 15.3713 15.4049 15.0962C15.6722 14.8212 16.0347 14.6667 16.4126 14.6667Z"
      fill={color}
    />
  </svg>
);
export const SearchFlightIcon = ({ color = '#8897A5' }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
  >
    <path
      d="M18.9996 12.58C18.9996 12.22 18.8096 11.89 18.5096 11.69L10.9996 7V1.5C10.9996 0.67 10.3296 0 9.49964 0C8.66964 0 7.99964 0.67 7.99964 1.5V7L0.489642 11.69C0.275582 11.8264 0.11818 12.0357 0.0465654 12.2792C-0.0250495 12.5228 -0.00602917 12.784 0.100107 13.0145C0.206243 13.2451 0.392309 13.4294 0.623871 13.5334C0.855433 13.6374 1.11681 13.6539 1.35964 13.58L7.99964 11.5V17L6.19964 18.35C6.13634 18.3954 6.08506 18.4556 6.05021 18.5253C6.01537 18.595 5.99801 18.6721 5.99964 18.75V19.34C5.99964 19.67 6.31964 19.91 6.63964 19.82L9.49964 19L12.3596 19.82C12.6796 19.91 12.9996 19.67 12.9996 19.34V18.75C13.0013 18.6721 12.9839 18.595 12.9491 18.5253C12.9142 18.4556 12.8629 18.3954 12.7996 18.35L10.9996 17V11.5L17.6396 13.58C18.3196 13.79 18.9996 13.28 18.9996 12.58Z"
      fill={color}
    />
  </svg>
);

export const MyBookingFlightIcon = ({ color }: { color?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect
      width="24"
      height="24"
      rx="12"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.18111 8.79255C10.3053 9.84655 10.8951 10.4012 10.9506 10.4564C10.9604 10.4662 10.9705 10.4766 10.9811 10.4874C11.0598 10.5682 11.1591 10.6701 11.2898 10.6757C11.4381 10.682 13.5725 10.6505 13.643 10.6412L13.6448 10.641C13.7154 10.6317 13.8272 10.6171 13.7686 10.4886C13.7095 10.3591 10.9274 8.4666 10.5445 8.24126C10.4892 8.20876 10.4428 8.17998 10.4019 8.1546C10.159 8.00404 10.1095 7.97332 9.55845 7.9959C9.50085 7.99826 9.44761 8.00031 9.39837 8.00221C8.89713 8.02155 8.80922 8.02494 8.73325 8.17355C8.66641 8.30429 8.80308 8.43315 9.01311 8.63118C9.06525 8.68034 9.12191 8.73377 9.18111 8.79255ZM16.9897 13.2316C18.2166 13.2365 18.7965 12.6574 18.7965 12.219C18.7965 11.7806 18.6256 11.3245 17.4088 11.1601C16.5976 11.0505 13.5115 11.0584 8.15051 11.1839C8.03688 11.1815 8.0122 11.172 7.91712 11.0943C7.47534 10.6425 7.19569 10.3569 7.07815 10.2374C6.90184 10.0581 6.5444 9.96485 6.20786 9.96956C5.87132 9.97426 5.76107 10.1571 5.78809 10.3216C5.8151 10.486 5.85013 10.5997 5.89262 10.7044C5.92095 10.7742 6.21255 11.4956 6.76743 12.8685C6.87528 13.1107 7.08628 13.2587 7.36447 13.2316L10.6707 13.2146C10.7785 13.2146 10.8233 13.275 10.8233 13.3402C10.8217 13.3702 10.8042 13.4276 10.7112 13.5266C10.2413 14.0274 8.929 15.4335 8.74578 15.6351C8.72402 15.659 8.70045 15.6844 8.67585 15.7109C8.49333 15.9073 8.25394 16.165 8.27312 16.3541C8.2949 16.5686 8.56546 16.5896 8.74578 16.5896C8.96409 16.5896 9.0941 16.5901 9.20198 16.5905C9.37066 16.5912 9.48523 16.5916 9.79869 16.5896L9.81055 16.5896C10.3142 16.5864 10.4137 16.5858 10.6707 16.3541C10.8608 16.1815 11.9777 15.1579 14.0214 13.2832C14.1021 13.2472 14.1242 13.2397 14.2412 13.2337C15.2429 13.2393 16.159 13.2386 16.9897 13.2316Z"
      fill="white"
    />
  </svg>
);

export const MyBookingBusIcon = ({ color }: { color?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      rx="12"
      fill={color}
    />
    <path
      d="M8.67445 4.66797C7.37855 4.66797 5.82422 5.39446 5.82422 7.35295V16.4013C5.82422 16.4013 5.82422 17.3791 6.7743 17.3791V18.3569C6.7743 18.3569 6.7743 19.3346 7.72438 19.3346C8.67445 19.3346 8.67445 18.3569 8.67445 18.3569V17.3791H15.325V18.3569C15.325 18.3569 15.325 19.3346 16.2751 19.3346C17.2252 19.3346 17.2252 18.3569 17.2252 18.3569V17.3791C17.2252 17.3791 18.1752 17.3791 18.1752 16.4013V7.35295C18.1752 5.35339 17.0009 4.66797 15.705 4.66797H8.67445ZM8.91197 6.13464H15.0875C15.1505 6.13464 15.2109 6.16039 15.2554 6.20623C15.3 6.25207 15.325 6.31425 15.325 6.37908C15.325 6.44391 15.3 6.50609 15.2554 6.55193C15.2109 6.59777 15.1505 6.62352 15.0875 6.62352H8.91197C8.84898 6.62352 8.78857 6.59777 8.74402 6.55193C8.69948 6.50609 8.67445 6.44391 8.67445 6.37908C8.67445 6.31425 8.69948 6.25207 8.74402 6.20623C8.78857 6.16039 8.84898 6.13464 8.91197 6.13464ZM7.72438 7.6013H16.2751C17.2252 7.6013 17.2252 8.54681 17.2252 8.54681V11.5124C17.2252 11.5124 17.2252 12.4902 16.2751 12.4902H7.72438C6.7743 12.4902 6.7743 11.5124 6.7743 11.5124V8.57908C6.7743 8.57908 6.7743 7.6013 7.72438 7.6013ZM7.72438 14.4457C7.97635 14.4457 8.21801 14.5488 8.39618 14.7321C8.57436 14.9155 8.67445 15.1642 8.67445 15.4235C8.67445 15.6828 8.57436 15.9315 8.39618 16.1149C8.21801 16.2983 7.97635 16.4013 7.72438 16.4013C7.4724 16.4013 7.23074 16.2983 7.05257 16.1149C6.87439 15.9315 6.7743 15.6828 6.7743 15.4235C6.7743 15.1642 6.87439 14.9155 7.05257 14.7321C7.23074 14.5488 7.4724 14.4457 7.72438 14.4457ZM16.2751 14.4457C16.5271 14.4457 16.7687 14.5488 16.9469 14.7321C17.1251 14.9155 17.2252 15.1642 17.2252 15.4235C17.2252 15.6828 17.1251 15.9315 16.9469 16.1149C16.7687 16.2983 16.5271 16.4013 16.2751 16.4013C16.0231 16.4013 15.7815 16.2983 15.6033 16.1149C15.4251 15.9315 15.325 15.6828 15.325 15.4235C15.325 15.1642 15.4251 14.9155 15.6033 14.7321C15.7815 14.5488 16.0231 14.4457 16.2751 14.4457Z"
      fill="white"
    />
  </svg>

);

export const NoResultSearchIcon = () => (
  <img
    src="https://storage.googleapis.com/goyolo-production/city-not-found-icon.webp"
    width="150"
    height="89"
    alt="city not found icon"
  />
);
